import React from 'react';
import { Helmet } from 'react-helmet';
import './PrivacyPolicy.scss';

const PrivacyPolicy = () => {
  return (
    <div className='privacy-policy-page'>
      <Helmet>
        <link rel="canonical" href="https://marketingv8.co/privacy-policy" />
        <title>Privacy Policy - Marketing v8</title>
        <meta name="description" content="Privacy Policy of Marketing v8 - learn how we process your personal data." />
        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://marketingv8.co/privacy-policy" />
        <meta property="og:title" content="Privacy Policy - Marketing v8" />
        <meta property="og:description" content="Privacy Policy of Marketing v8 - learn how we process your personal data." />
        <meta property="og:image" content="https://marketingv8.co/logov8.png" />
      </Helmet>

      <div className='privacy-policy-hero'>
        <h1>Privacy Policy</h1>
      </div>

      <div className='privacy-policy-content'>

        <p><strong>Dear User!</strong></p>
        <p>
          We care about your privacy and we want you to feel comfortable while using our services. Therefore, below we present the most important information about the principles of processing your personal data by us and cookies that are used by our Website. This information has been prepared taking into account the GDPR, i.e. the general data protection regulation.
        </p>

        <h2>Personal Data Administrator</h2>
        <p>
          PAWEŁ SCHARMACH, an entrepreneur running a business under the name of Marketing V8 Sp. z o.o., entered into the Central Register and Information on Economic Activity kept by the Minister of Development and Finance, NIP 5922290210, KRS number 0000985995, ul. Rybacka 16, 83-200 Rokocin.
        </p>

        <h2>Personal Data and Privacy</h2>
        <p>
          If you intend to set up a User Account and use our services, you will be asked to provide us with your personal data. Your data is processed by us for the purposes indicated below, related to the functioning of the Website and the provision of services offered on it ("Services").
        </p>

        <h3>Purpose of processing:</h3>
        <p>Depending on what you decide to do, it could be:</p>
        <ul>
          <li>Provision of services offered on the Website</li>
          <li>Fulfillment of your orders</li>
          <li>Sending the newsletter</li>
          <li>Delivery of the ordered offer</li>
        </ul>

        <h3>The basis for processing:</h3>
        <ul>
          <li>Sales contract (Article 6 (1) (b) of the GDPR)</li>
          <li>Legal obligation binding on us, e.g. related to accounting (Article 6 (1) (c) of the GDPR)</li>
          <li>Your consent expressed in the Store (Article 6 (1) (a) of the GDPR)</li>
          <li>Contract for the provision of services (Article 6 (1) (b) of the GDPR)</li>
          <li>Our legitimate interest to establish, assert or defend claims (Article 6 (1) (f) of the GDPR)</li>
        </ul>

        <h3>Providing data:</h3>
        <p>Voluntary, but in some cases may be necessary to conclude a contract or submit an offer.</p>

        <h3>The effect of not providing data:</h3>
        <p>Depending on the purpose for which the data is provided:</p>
        <ul>
          <li>No possibility to register on the Website</li>
          <li>Inability to use the Website's services</li>
          <li>No possibility to make purchases on the Website</li>
          <li>No possibility to receive information about promotions or special offers offered on the Website</li>
        </ul>

        <h3>Possibility to withdraw consent:</h3>
        <p>Anytime. The processing of data until you withdraw your consent remains lawful.</p>

        <h2>Processing Period</h2>
        <p>We will process your data only for the period in which we will have a legal basis, i.e. until:</p>
        <ul>
          <li>The legal obligation that obliges us to process your data will cease to bind us</li>
          <li>The possibility of pursuing claims related to the contract concluded by the Website by either party will cease</li>
          <li>You will withdraw your consent to the processing of data, if it was its basis</li>
        </ul>
        <p>— depending on what is applicable in a given case and what will happen at the latest.</p>

        <h2>Data Safety</h2>
        <p>When processing your personal data, we use organizational and technical measures in accordance with the applicable law.</p>

        <h2>Your Rights</h2>
        <p>You have the right to request:</p>
        <ul>
          <li>Access to your personal data</li>
          <li>Correct them</li>
          <li>Deletion</li>
          <li>Processing restrictions</li>
        </ul>
        <p>And also the right to:</p>
        <ul>
          <li>Object to processing</li>
          <li>Request to transfer data to another administrator</li>
        </ul>
        <p>
          Please contact us if you want to exercise your rights. If you believe that your data is being processed unlawfully, you can submit a complaint to the supervisory authority.
        </p>

        <h2>Cookies</h2>
        <p>Our website, like most websites, uses the so-called cookies. These files:</p>
        <ul>
          <li>Are saved in the memory of your device (computer, telephone, etc.)</li>
          <li>Enable you, among other things, to use all the functions of the Website</li>
          <li>Do not change the settings of your device</li>
        </ul>

        <p>By using the appropriate options of your browser, you can at any time:</p>
        <ul>
          <li>Delete cookies</li>
          <li>Block the use of cookies in the future</li>
        </ul>

        <p>On this website, cookies are used for the following purposes:</p>
        <ul>
          <li>Remembering information about your session</li>
          <li>Statistical</li>
          <li>Marketing</li>
          <li>Providing the functions of the Website</li>
        </ul>

        <p>
          To learn how to manage cookies, including how to disable them in your browser, you can use your browser's help file. You can read the information on this subject by pressing the F1 key in the browser. In addition, relevant tips can be found on the following subpages, depending on the browser you use: Firefox, Chrome, Safari, Internet Explorer / Microsoft Edge.
        </p>
        <p>If you do not disable the use of cookies in your browser settings, it means that you consent to their use.</p>

        <h2>External Services / Data Recipients</h2>
        <p>We use the services of external entities to which your data may be transferred. Below is a list of these entities:</p>
        <ul>
          <li>The entity delivering the goods</li>
          <li>Wholesaler</li>
          <li>Printing house</li>
          <li>Payment provider</li>
          <li>Accounting office</li>
          <li>Hosting provider</li>
          <li>An entity that facilitates the optimization of the Website</li>
          <li>People cooperating with us on the basis of civil law contracts, supporting our current activity</li>
          <li>Software provider that facilitates running a business (e.g. accounting software)</li>
          <li>An entity providing marketing services</li>
          <li>Software provider needed to run an online store</li>
        </ul>

        <h2>Contact with the Administrator</h2>
        <p>
          Do you want to exercise your personal data rights? Or maybe you just want to ask about something related to our Privacy Policy?
        </p>
        <p>
          Write to the e-mail address: <a href='mailto:office@marketingv8.co'>office@marketingv8.co</a>
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
